// Import all translation files
import actions from './actions';
import advisory from './advisory';
import components from './components';
import configurator from './configurator';
import errors from './errors';
import general from './general';
import links from './links';
import shoppingCart from './shopping-cart';
import systems from './systems';
import units from './units';

module.exports = {
  actions,
  advisory,
  components,
  configurator,
  errors,
  general,
  links,
  shoppingCart,
  systems,
  units,
};



// WEBPACK FOOTER //
// ./js/lang/nl/index.js